// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as yup from 'yup'

import {
  Driver,
  EntityConstants,
  DigitPattern,
  AlphanumericAndSpacePattern,
  DEFAULT_VAT_CATEGORY_ID,
} from 'constants/index'
import { PaymentTerm } from 'generated/graphql'
import {
  yupPhoneValidator,
  yupPhoneOptionalValidator,
  phoneValidationMessages,
} from 'helpers/phoneValidation.helpers'

function DriverOnboardingDialogValidation(vatCategoryId: string) {
  const defaultVatCategoryId = vatCategoryId === DEFAULT_VAT_CATEGORY_ID
  return yup.object().shape({
    name: yup.string().required().max(EntityConstants.MAX_NAME_LENGTH),

    vatIdNumber: defaultVatCategoryId
      ? yup
        .string()
        .trim()
        .nullable()
        .notRequired()
        .max(
          EntityConstants.MAX_VAT_ID_NUMBER_LENGTH,
          `Vat Reg. Num must be at most ${EntityConstants.MAX_VAT_ID_NUMBER_LENGTH} characters`,
        )
      : yup
        .string()
        .trim()
        .required('Vat Reg. Num is required')
        .test(
          'not-empty-or-null',
          'Vat Reg. Num is required',
          (value) => value !== '' && value !== null,
        )
        .max(
          EntityConstants.MAX_VAT_ID_NUMBER_LENGTH,
          `Vat Reg. Num must be at most ${EntityConstants.MAX_VAT_ID_NUMBER_LENGTH} characters`,
        ),

    eoriNumber: yup
      .string()
      .nullable()
      .max(
        EntityConstants.MAX_EORI_NUMBER_LENGTH,
        `EORI number must be at most ${EntityConstants.MAX_EORI_NUMBER_LENGTH} characters`,
      ),
    startDate: yup.date().typeError('Start date is a required field').required(),
    email: yup.string().email().required().max(EntityConstants.MAX_EMAIL_LENGTH),
    invoiceEmail: yup.string().email().nullable().max(EntityConstants.MAX_EMAIL_LENGTH),
    endorsements: yup
      .string()
      .nullable()
      .max(
        Driver.MAX_NOTE_LENGTH,
        `Endorsements must be at most ${Driver.MAX_NOTE_LENGTH} characters`,
      ),
    addressLine1: yup.string().required().max(EntityConstants.MAX_ADDRESS_LENGTH),
    addressLine2: yup.string().nullable().max(EntityConstants.MAX_ADDRESS_LENGTH),
    city: yup.string().required().max(EntityConstants.MAX_CITY_LENGTH),
    countryId: yup.number().required().min(1, 'Country is a required field'),
    postcode: yup.string().required().max(EntityConstants.MAX_POSTCODE_LENGTH),
    telephoneNumber: yup
      .string()
      .required()
      .test('is-valid-phone', phoneValidationMessages['invalid.phone.number'], yupPhoneValidator),
    alternativeTelephoneNumber: yup
      .string()
      .optional()
      .test(
        'is-valid-alternative-phone',
        phoneValidationMessages['invalid.phone.number'],
        yupPhoneOptionalValidator,
      )
      .nullable(),
    currencyId: yup.string().required(),
    bankName: yup
      .string()
      .nullable()
      .max(
        Driver.MAX_BANK_NAME_LENGTH,
        `Bank Name must be at most ${Driver.MAX_BANK_NAME_LENGTH} characters`,
      ),
    bankAccountNumber: yup
      .string()
      .required()
      .length(
        Driver.MAX_BANK_ACCOUNT_NUMBER_LENGTH,
        `The Account Number is an ${Driver.MAX_BANK_ACCOUNT_NUMBER_LENGTH} digits long code with no dashes or spaces.`,
      )
      .matches(
        DigitPattern,
        `The Account Number is an ${Driver.MAX_BANK_ACCOUNT_NUMBER_LENGTH} digits long code with no dashes or spaces.`,
      ),
    bankAccountHolderName: yup
      .string()
      .required()
      .max(
        Driver.MAX_BANK_ACCOUNT_HOLDER_NAME_LENGTH,
        `Bank Account Holder Name must be at most ${Driver.MAX_BANK_ACCOUNT_HOLDER_NAME_LENGTH} characters`,
      )
      .matches(
        AlphanumericAndSpacePattern,
        'Only alphanumeric characters, spaces and dashes are allowed. Numeric characters are forbidden.',
      ),
    bankSortCode: yup
      .string()
      .required()
      .length(
        EntityConstants.MAX_BANK_SORT_CODE_LENGTH,
        `The Sort Code is a ${EntityConstants.MAX_BANK_SORT_CODE_LENGTH} digits long code with no dashes or spaces.`,
      )
      .matches(
        DigitPattern,
        `The Sort Code is a ${EntityConstants.MAX_BANK_SORT_CODE_LENGTH} digits long code with no dashes or spaces.`,
      ),
    internationalBankAccountNumber: yup
      .string()
      .nullable()
      .max(
        Driver.MAX_BANK_INTERNATIONAL_ACCOUNT_NUMBER_LENGTH,
        `Bank International Account Number must be at most ${Driver.MAX_BANK_INTERNATIONAL_ACCOUNT_NUMBER_LENGTH} characters`,
      ),
    paymentTerm: yup.string().oneOf(Object.values(PaymentTerm)).required(),
    vatCategoryId: yup.string().required(),
    swift: yup.string().nullable(),
    companyRegistrationNumber: yup
      .string()
      .nullable()
      .max(
        EntityConstants.MAX_GENERIC_TEXT_LENGTH,
        `Company Registration Number must be at most ${EntityConstants.MAX_GENERIC_TEXT_LENGTH} characters`,
      ),
  })
}

export default DriverOnboardingDialogValidation
